var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"video",style:({visibility: 'hidden', position: 'fixed', top:0, left: 0}),attrs:{"width":"800","autoplay":"true","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }